import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { faTerminal, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Subscription } from 'rxjs';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import * as bootstrap from 'bootstrap';
import { CreateGyanService } from 'src/app/core/services/create-gyan/create-gyan.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-main-panel',
    templateUrl: './main-panel.component.html',
    styleUrls: ['./main-panel.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state(
                'expanded',
                style({
                    width: '66.66%',
                }),
            ),
            state(
                'collapsed',
                style({
                    width: '0%',
                }),
            ),
            transition('expanded => collapsed', [animate('0.3s')]),
            transition('collapsed => expanded', [animate('0.3s')]),
        ]),
    ],
})
export class MainPanelComponent implements OnInit {
    @Input() PreviousgyanId: any;
    @Input() allGyanList: any;
    @Input() isLoading: any;
    private modalRef: NgbModalRef | undefined;
    @ViewChild('owlCarousel') owlCarousel: any;

    private previousGyanClicked: Subscription;
    private previousGyanOnload: Subscription;
    private createGyanInitiated: Subscription;
    private articleLongStory: Subscription;
    private articleLongStoryDataActual: Subscription;
    private openSubmitGyan: Subscription;
    private showAdvancyQueryFormPage: Subscription;
    private resetArticleList: Subscription;
    private CallFromSocketForGyanStatus: Subscription;
    private showSaveDraftListPage: Subscription;
    private callUseAsTemplate: Subscription;

    faTerminal = faTerminal;
    dataTypeIsGyan: boolean = false; // this variable is to check dataType
    faArrowLeft = faArrowLeft;
    articleExpanded: boolean = false;
    showDashboardHome = true; // to show or hide the home page
    showArticleNetworkGraph = false;
    showGyanOrganisation = false; // to show or hide the submit gyan page
    GyanName: any;
    isMobile: boolean = false;
    longStoryData: any;
    paraClickId: any;
    clickbackparas: any;
    fromPreviousGyanClick: boolean = false;
    currentScreenIndex: number = 0;
    hideDashboard: boolean = false;
    hideforGyan = false; //flag to hide or show the search bar for advanced queries
    @ViewChild('subscriptionMessageModal') subscriptionMessageModal!: ElementRef; // Reference to the modal
    @ViewChild('gyanFinishedModal') gyanFinishedModal!: ElementRef; // Reference to the modal
    @ViewChild('confirmChangesModal') confirmChangesModal!: TemplateRef<any>;
    newGyanCreated: boolean = false; // for mobile loading carousel
    SubmitgyanService: any;
    gyanId: any;
    gyanStatusfromSocket: any; //gyan live status to send to MDS component
    openStatuspopup = false;
    clicbackDataSet: boolean = false;
    showSubmitGyan: boolean = false;
    owlCarouselSlide: number = 0;
    showSaveDraftList = false;
    // eslint-disable-next-line sonarjs/cognitive-complexity
    constructor(
        private commonServiceService: CommonServiceService,
        private localstorageservice: LocalStorageService,
        private submitgyanservice: SubmitgyanService,
        private creategyanservice: CreateGyanService,
        private modalService: NgbModal,
        private cd: ChangeDetectorRef,
    ) {
        this.checkWidth();

        // calling subject to show and hide dahsboard screen
        this.previousGyanClicked = this.commonServiceService.previousGyanClick$.subscribe((value) => {
            console.log('MainPanelComponent.previousGyanClick.value', value);
            if (value.callMDS || value.callArticles) {
                this.showDashboardHome = false;
                this.showSaveDraftList = false;
                const gyanData = this.localstorageservice.getItem('gyanData');
                this.GyanName = gyanData.gyanName;
                this.gyanId = gyanData.gyanId;
                console.log('calling subject to show and hide dahsboard screen', gyanData);
                this.fromPreviousGyanClick = true;
                this.articleExpanded = false;
                this.showGyanOrganisation = false;
                this.newGyanCreated = false;
                //when the user selects any gyan from advanced queries list then hide the search bar
                if (gyanData.gyanType === 'gyan' && !value.callType) {
                    this.hideforGyan = true;
                    if (this.isMobile) {
                        console.log('creating gyan from mobile');
                        setTimeout(() => {
                            this.owlCarousel.prev();
                        }, 100);
                    }
                    //calling the below API to get live gyan status
                    this.submitgyanservice.getGyanStatus(gyanData.gyanId).subscribe((data) => {
                        console.log('the gyan status is', data);
                        //sending this status to MDS component to display the icons of gyan progress
                        this.gyanStatusfromSocket = data.status;
                        const gyanDetails = this.localstorageservice.getItem('gyanData');
                        const gyanData = {
                            gyanName: gyanDetails.gyanName,
                            gyanId: gyanDetails.gyanId,
                            gyanType: gyanDetails.gyanType,
                            gyanCreatedNow: gyanDetails.gyanCreatedNow,
                            gyanStatus: data.status,
                            callType: value.callType,
                        };
                        this.localstorageservice.setItem('gyanData', gyanData);
                    });
                } else {
                    if (!value.callType) {
                        this.hideforGyan = false;
                    }
                }
            }
        });

        // calling subject to show and hide dahsboard screen
        this.previousGyanOnload = this.commonServiceService.previousGyanOnload$.subscribe((value) => {
            if (value) {
                this.showDashboardHome = false;
                //        console.log('calling subject to show and hide dahsboard screen');
            }
        });

        // eslint-disable-next-line sonarjs/cognitive-complexity
        //calling subject after initiated gyan to show dashboard screen
        /* eslint-disable sonarjs/cognitive-complexity */
        this.createGyanInitiated = this.commonServiceService.createGyanInitiated$.subscribe((value) => {
            if (value) {
                this.showDashboardHome = false; //hiding dashboard when gyan created
                this.showGyanOrganisation = false; //hiding advance query form when gyan created
                this.showSaveDraftList = false;
                //        console.log('calling subject after initiated gyan to show dashboard screen');
                const gyanData = this.localstorageservice.getItem('gyanData');
                this.GyanName = gyanData.gyanName;
                this.fromPreviousGyanClick = false;
                this.newGyanCreated = true;

                if (gyanData.gyanType === 'rapid') {
                    this.articleExpanded = false;
                    console.log(this.owlCarouselSlide);
                    if (this.owlCarouselSlide === 1) this.owlCarousel.prev();
                }
                if (gyanData.gyanType === 'gyan') {
                    //when the user creates any new gyan (advanced queries) then hide the search bar
                    this.hideforGyan = true;
                    //when a user submits a new gyan then redirect to the longstory page and hide the search bar
                    if (gyanData.gyanCreatedNow === 'yes') {
                        this.gyanStatusfromSocket = gyanData.gyanStatus;
                        //changed the below value to false to navigate to MDS page after submission
                        if (this.creategyanservice.pksSelected) this.articleExpanded = false;
                        else this.articleExpanded = true;
                        this.showArticleNetworkGraph = false;
                        if (this.isMobile) {
                            this.articleExpanded = false;
                            console.log('creating gyan from mobile');
                            if (!this.creategyanservice.pksSelected) {
                                // setTimeout(() => {
                                //     this.owlCarousel.next();
                                // }, 100);
                            }
                        }
                    } else this.articleExpanded = false;
                }
            }
        });

        //callling subject to open article Network
        this.commonServiceService.articleNetworkSubject$.subscribe((data: any) => {
            if (data?.articleId) {
                this.showArticleNetworkGraph = true;
                this.articleExpanded = true;
            }
        });

        // calling subject to show and hide dahsboard screen
        this.commonServiceService.gotoDashboard$.subscribe((data: any) => {
            // if (data) {
            this.showDashboardHome = true;
            this.articleExpanded = false;
            this.showGyanOrganisation = false;
            const gyanData = this.localstorageservice.getItem('gyanData');
            if (gyanData?.gyanType == 'rapid') {
                this.showGyanOrganisation = false;
                this.hideforGyan = false;
                this.showSaveDraftList = false;
            }
            //when user clicks on Gyan Icon then display the searchbar
            // }
        });

        this.articleLongStory = this.commonServiceService.articleLongStory$.subscribe((value) => {
            if (value) {
                this.articleExpanded = true;
                this.showArticleNetworkGraph = false;
            }
        });

        //callling subject to open article Network
        this.articleLongStoryDataActual = this.commonServiceService.articleLongStoryDataActual.subscribe((data: any) => {
            //console.log('articleLongSotryActualData', data);
            if (data?.longStoryData) {
                // if(data.longStoryData == undefined){
                //     this.longStoryData = {}
                // }
                // else{
                //  console.log(Object.keys(data.longStoryData).length);
                if (Object.keys(data.longStoryData).length > 0) {
                    //    console.log('Inside If');
                    this.longStoryData = data.longStoryData;
                }
                this.paraClickId = data.articleRecordId;
            }
        });

        this.openSubmitGyan = this.commonServiceService.openSubmitGyan$.subscribe((data: any) => {
            if (data) {
                console.log('mainpanel.openSubmitGyan.data', data);
                this.showGyanOrganisation = true;
                this.showDashboardHome = false;
                this.showSubmitGyan = false;
                this.showSaveDraftList = false;
            }
        });

        //calling subject to load Draft list
        this.showSaveDraftListPage = this.commonServiceService.showDraftListPage$.subscribe((data: any) => {
            if (data) {
                console.log('data', data);
                this.showSaveDraftList = true;
                this.showGyanOrganisation = false;
                this.showDashboardHome = false;
                this.showSubmitGyan = false;
            }
        });

        //calling subject to load Advance Query form
        this.showAdvancyQueryFormPage = this.commonServiceService.showAdvancyQueryFormPage$.subscribe((value) => {
            if (value) {
                console.log('mainpanel.showAdvancyQueryFormPage.value', value);
                this.showDashboardHome = false; //hiding dashboard when gyan created
                this.showGyanOrganisation = true; //showing advance query form when gyan created
                this.showSaveDraftList = false;
                //this.showSubmitGyan = true;
                this.showSubmitGyan = false;
            }
        });

        //The below subject will be called when the current gyan is finished / failed
        this.CallFromSocketForGyanStatus = this.commonServiceService.CallFromSocketForGyanStatus$.subscribe((value) => {
            console.log('Inside the socket call');
            // this.showGyanStatusModal();
            if (value.data?.gyanStatus == 'FINISHED') {
                //once the current gyan is finished display the dialog box to confirm the reload
                this.showGyanStatusModal();
            }
            if (value.data?.gyanStatus) this.gyanStatusfromSocket = value.data.gyanStatus;
            const gyanDetails = this.localstorageservice.getItem('gyanData');
            if (gyanDetails) {
                console.log('the gyandetail', gyanDetails);
                const gyanData = {
                    gyanName: gyanDetails.gyanName,
                    gyanId: gyanDetails.gyanId,
                    gyanType: gyanDetails.gyanType,
                    gyanCreatedNow: gyanDetails.gyanCreatedNow,
                    gyanStatus: value.data.gyanStatus,
                };
                this.localstorageservice.setItem('gyanData', gyanData);
            }
        });

        //calling subject when we reset article list after removing the highlight of MDS
        this.resetArticleList = this.commonServiceService.resetArticleList$.subscribe((value) => {
            if (value) {
                this.clickBackArticleList = null;
            }
        });

        this.submitgyanservice.callSubmitGyanEvent$.subscribe((data: boolean) => {
            this.showGyanOrganisation = true;
            this.showDashboardHome = false;
            this.showSaveDraftList = false;
            this.showSubmitGyan = data;
        });

        this.callUseAsTemplate = this.commonServiceService.callUseAsTemplate$.subscribe((topicId: any) => {
            //calling subject to show create gyan page
            //console.log("topicId",topicId);
            if (topicId) this.hideDashboardAndShowAdvanceCreateGyan(topicId);
        });
    }
    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: true,
        navSpeed: 700,
        navText: ['', ''],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            740: {
                items: 1,
            },
            940: {
                items: 1,
            },
        },
    };
    clickBackArticleList: any;

    ngOnInit() {
        this.submitgyanservice.callSubmitGyanEvent$.subscribe((data: boolean) => {
            console.log('callFindByNameEvent.data', data);
            this.showSubmitGyan = data;
        });
    }

    showMDS() {
        // we are clicking on back button to show MDS
        this.articleExpanded = false;
        const obj = {
            callMDS: true,
            callArticles: false,
        };
        this.commonServiceService.setPreviousGyanClick(obj);
        this.commonServiceService.setFindMoreArticleClick(true);
        this.commonServiceService.setdisablehighlight(true);
        this.commonServiceService.articleNetworkResetSubject.next(true);
        this.commonServiceService.setSelectedId(this.commonServiceService.paraIdselected);
    }

    receiveClickbackList(event: any) {
        console.log('receiveClickbackList');
        const gyanData = this.localstorageservice.getItem('gyanData');
        this.clicbackDataSet = true;
        if (gyanData.gyanType === 'rapid') {
            console.log('the clickBackArticleList', event);
            this.clickBackArticleList = event.data.articleList;
        } else {
            this.clickBackArticleList = event.data[0].paragraphs;
        }

        this.fromPreviousGyanClick = false;
        if (this.isMobile) this.owlCarousel.next();
    }

    receiveClickbackparas(event: any) {
        this.clickbackparas = event;
        //    console.log(' this.clickbackparas', this.clickbackparas);
    }

    checkWidth() {
        const width = window.innerWidth;
        //    console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    hideDashboardAndShowAdvanceCreateGyan(topicId: any) {
        this.showDashboardHome = false; //hiding dashboard when gyan created
        this.showGyanOrganisation = true;
        this.showSubmitGyan = true;

        //calling subject after loading create gyan page
        this.commonServiceService.setTemplateDataSubject(topicId);
    }

    ngOnDestroy() {
        this.previousGyanClicked.unsubscribe();
        this.previousGyanOnload.unsubscribe();
        this.createGyanInitiated.unsubscribe();
        this.articleLongStory.unsubscribe();
        this.articleLongStoryDataActual.unsubscribe();
        this.showAdvancyQueryFormPage.unsubscribe();
        this.resetArticleList.unsubscribe();
        this.callUseAsTemplate.unsubscribe();
        this.showSaveDraftListPage.unsubscribe();
        this.modalRef?.close();
    }

    onTranslated(event: any): void {
        //console.log('this function called', event.startPosition);
        this.owlCarouselSlide = event.startPosition;
        //console.log('owlCarouselSlide', this.owlCarouselSlide);
        //    console.log('this function called', this.fromPreviousGyanClick);
        if (event.startPosition === 0) {
            this.articleExpanded = false;
            this.showArticleNetworkGraph = false;
            this.fromPreviousGyanClick = false;
        }

        const gyanData = this.localstorageservice.getItem('gyanData');
        if (this.fromPreviousGyanClick === true && event.startPosition === 1 && gyanData.gyanType === 'rapid') {
            console.log('if');
            this.owlCarousel.prev();
            this.fromPreviousGyanClick = false;
        }

        if (this.newGyanCreated === true && event.startPosition === 1 && gyanData.gyanType === 'rapid') {
            console.log('new Created');
            //   this.owlCarousel.prev();
            this.newGyanCreated = false;
        }
    }

    onsubscriptionMessageModal(newValue: boolean): void {
        console.log('newValue.....', newValue);
        if (newValue === true) {
            this.showSubscriptionMessageModal();
        }
    }

    showSubscriptionMessageModal() {
        const modalElement = this.subscriptionMessageModal.nativeElement;
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
    }

    closeSubscriptionMessageModal() {
        const modalElement = this.subscriptionMessageModal.nativeElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    }

    showGyanStatusModal() {
        if (!this.showDashboardHome && !this.showSubmitGyan && !this.showSaveDraftList) {
            this.openStatuspopup = true;
        }
        // const modalElement = this.gyanFinishedModal.nativeElement;
        // const modalInstance = new bootstrap.Modal(modalElement);
        // modalInstance.show();
        // this.openStatuspopup = true;
    }

    confirmReload() {
        console.log('the button confirm is selected');
        const obj = {
            callMDS: true,
            callArticles: true,
        };
        this.commonServiceService.setPreviousGyanClick(obj);
        //subject to update gyan status of finished gyans(to dashboard component)
        this.commonServiceService.setGyanStatus(true);
        this.openStatuspopup = false;
    }

    closeGyanStatusModal() {
        // console.log("the button close is selected")
        // const modalElement = this.gyanFinishedModal.nativeElement;
        // const modalInstance = bootstrap.Modal.getInstance(modalElement)
        // if (modalInstance) {
        //     modalInstance.hide();
        // }
        this.openStatuspopup = false;
    }

    moveGyanNameToAdvanceQuery() {
        this.modalRef?.close();
        // console.log('moveGyanNameToAdvanceQuery');
        //this sets true when we need to go the Advace Query Form Page.
        const gyanData = this.localstorageservice.getItem('gyanData');
        localStorage.setItem('tempGyanName', gyanData.gyanName);
        //    localStorage.removeItem('gyanData');
        //this.commonServiceService.setShowAdvancyQueryFormPage(false);
        this.commonServiceService.setShowAdvancyQueryFormPage(false);
        const data = {};
        this.commonServiceService.setTemplateDataSubject(data);
        this.submitgyanservice.emitSubmitGyanClickEvent(true);
    }
    isGyanSelected = false;
    rootTopicId: any;

    createGysnBtnClick() {
        this.localstorageservice.setItem('rootGyanId', '');

        //should be removed when save draft implemented
        // this.commonServiceService.setTemplateDataSubject({});
        // this.commonServiceService.setTemplateDataSubjectForSources({});
        // this.commonServiceService.setTemplateDataSubjectForTopicOutline({});
        // this.commonServiceService.setTemplateDataSubjectForConfig({});

        // this.localstorageservice.setItem('rootTopicId', null);
        this.rootTopicId = 0; //this.localstorageservice.getItem('rootGyanId');
        // if (this.isGyanSelected) {
        //     this.isGyanSelected = false;
        // }
        console.log('createGysnBtnClick');
        const gyanData = {
            gyanType: 'gyan',
        };
        this.localstorageservice.setItem('gyanData', gyanData);

        this.commonServiceService.setopenSubmitGyan(false);

        const storedData = localStorage.getItem('topicOutline');
        if (storedData) {
            const topicOutline = JSON.parse(storedData);
            console.log('topicOutline', topicOutline);
            if (topicOutline !== null) {
                if (topicOutline.name !== '') {
                    this.openConfirmChangesModal();
                } else {
                    console.log('createGysnBtnClick');
                    const data = {};
                    this.commonServiceService.setCallUseAsTemplate(data);
                    this.submitgyanservice.emitSubmitGyanClickEvent(true);
                }
            }
        } else {
            console.log('createGysnBtnClick');
            const data = {};
            this.commonServiceService.setCallUseAsTemplate(data);
            this.submitgyanservice.emitSubmitGyanClickEvent(true);
        }
        this.commonServiceService.setReOpenAdvancedQueries(true);
        localStorage.removeItem('tempGyanName');
    }

    onConfirmGyan() {
        if (this.modalRef) {
            this.modalRef.close(); // Closes the modal
        }
        console.log('createGysnBtnClick');
        this.commonServiceService.setConfirmGyan(true);
        this.commonServiceService.setTemplatetLoaded(true);
        this.commonServiceService.setCancelFlag(false);
        this.submitgyanservice.emitSubmitGyanClickEvent(true);
    }

    cancelConfirmGyan() {
        if (this.modalRef) {
            this.modalRef.close(); // Closes the modal
        }
        this.commonServiceService.setCancelFlag(true);
        this.commonServiceService.setConfirmGyan(false);
        this.commonServiceService.setTemplatetLoaded(false);
        this.commonServiceService.setDraftLoaded(null);
        console.log('createGysnBtnClick');
        const data = {};
        this.commonServiceService.setCallUseAsTemplate(data);
        this.submitgyanservice.emitSubmitGyanClickEvent(true);
    }

    openConfirmChangesModal() {
        this.modalRef = this.modalService.open(this.confirmChangesModal, {
            centered: true,
            size: this.isMobile ? 'sm' : 'ms',
            windowClass: this.isMobile ? 'custom-modal-class-confrim-mb' : 'custom-modal-class-confrim',
        });
    }
}
